import { useDragLayer } from 'react-dnd';
import { Paper, Typography } from '@mui/material';

const layerStyles: React.CSSProperties = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 1000,
  left: 0,
  top: 0,
};

export const CustomDragLayer = () => {
  const {
    isDragging,
    item,
    currentOffset,
  } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    isDragging: monitor.isDragging(),
    currentOffset: monitor.getSourceClientOffset(),
  }));

  if (!isDragging || !item || !currentOffset || item.type === 'CATEGORY') {
    return null;
  }

  let len = 0;
  if ( item.type === 'CATEGORY_ROW')
    len = item.categories.length;
  else if ( item.type === 'CONTENT_ROW')
    len = item.contents.length;

  if ( len > 1 ) {
      return (
        <div style={layerStyles}>
          <div
            style={{
              transform: `translate(${currentOffset.x}px, ${currentOffset.y}px)`,
            }}
          >
            <Paper sx={{ padding: 1, opacity: 0.8 }}>
              <Typography variant="body2" color="red">
                {len}
              </Typography>

            </Paper>
          </div>
        </div>
      );
    }
    else
    return (
        <div/>
    );
};
